/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  Area,
  AreaChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { Box, useTheme } from '@ttoss/ui';

import type { MyTheme } from '../../providers/ThemeProvider/theme';

import * as tooltipProps from '../ChartTooltip/tooltipProps';

const gradientOffset = ({ data }: { data: any }) => {
  const dataMax = Math.max(...data.map((item: any) => item.hydricVolume));
  const dataMin = Math.min(...data.map((item: any) => item.hydricVolume));

  if (dataMax <= 0) {
    return 0;
  }
  if (dataMin >= 0) {
    return 1;
  }

  return dataMax / (dataMax - dataMin);
};
export type ChartHydricBalanceProps = {
  data: {
    month: number;
    monthLabel: string;
    hydricVolume: number;
  }[];
};

const ChartHydricBalance = ({ data }: ChartHydricBalanceProps) => {
  const themeContext = useTheme();

  const theme = themeContext.theme as MyTheme;

  return (
    <Box style={{ width: '100%', height: theme.space[13] }}>
      <ResponsiveContainer debounce={1}>
        <AreaChart
          data={data}
          margin={{
            top: theme.space[6],
            right: theme.space[7],
            bottom: theme.space[6],
            left: theme.space[0],
          }}
        >
          <XAxis
            dataKey="monthLabel"
            tickLine={false}
            fontSize={theme.fontSizes[1]}
            padding={{ left: theme.space[4], right: theme.space[0] }}
          />
          <YAxis
            dataKey="hydricVolume"
            type="number"
            axisLine={false}
            unit=" mm"
            interval={2}
            domain={['dataMin - 15', 'dataMax + 15']}
            tickLine={false}
            fontSize={theme.fontSizes[1]}
            tickFormatter={(value) => Math.round(value).toString()}
          />
          <Tooltip {...tooltipProps} />
          <Legend
            verticalAlign="top"
            iconSize={theme.fontSizes[1]}
            wrapperStyle={{ fontSize: theme.fontSizes[3] }}
            height={theme.space[9]}
          />
          <defs>
            <linearGradient id="splitColor" x1="0" y1="0" x2="0" y2="1">
              <stop
                offset={gradientOffset({ data })}
                stopColor={theme.colors.secondary}
                stopOpacity={1}
              />
              <stop
                offset={gradientOffset({ data })}
                stopColor={theme.colors.caution}
                stopOpacity={1}
              />
            </linearGradient>
          </defs>
          <Area
            name="Volume Hídrico (mm)"
            type="monotone"
            dataKey="hydricVolume"
            stroke="url(#splitColor)"
            fill="url(#splitColor)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default ChartHydricBalance;
